import {
  type IGlobalEvent,
  type IGlobalEventContext,
} from "@/analytics/events/constants";

export const pushDataLayerPageView = (path: string) => {
  if (!window.koalaGoogleTagManagerConfigured) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "pageview",
    page: {
      path,
    },
  });
};

export const pushDataLayerGenericEvent = (
  event: IGlobalEvent,
  context: IGlobalEventContext
) => {
  if (!window.koalaGoogleTagManagerConfigured) {
    return;
  }

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: event.eventName || context.name,
  });
};
